<template>
  <div class="home text-center gy-3 pe-5">
    <h1>{{ $t("title") }}</h1>
    <div class="row pt-5 pb-4" id="capital">
      <div class="col-md-12">
        <div class="float-start text-start">
          <div class="float-end" style="max-width: 30%">
            <img
              src="@/assets/4590_Driving_Digital_Transformation.jpg"
              class="img-thumbnail shadow-sm rounded"
              alt="Digital Transformation"
            />
          </div>
          <h5>
            {{ $t("homeSubTitel") }}
          </h5>
          <p class="capitalize">
            {{ $t("homeParaOne") }}
          </p>
          <p class="capitalize">
            {{ $t("homeParaTwo") }}
          </p>
          <p class="capitalize">
            {{ $t("homeParaThree") }}
          </p>
        </div>
      </div>
    </div>
<!-- Start buttons -->
  <div class="row pb-4 ">
      <div class="d-grid gap-2 col-4 mx-auto">
    <!-- <button type="button" class="btn btn-primary"> {{$t("VDI2770CreatorAlone") }} </button> -->
    <!-- <button type="button" class="btn btn-primary"></button> -->
    <router-link
            to="/vdi2770viewer/files"
            class="btn btn-primary"
            :data-toggle="!getAcceptToS ? 'modal' : ''"
            data-target="#ToSModal"
            @click="checkToS()"
            >{{$t("VDI2770ViewerGoTo") }} <i class="bi bi-arrow-up-right-square"></i></router-link
          >
    </div>
  </div>
<!-- End buttons -->
    <div class="row pb-4">
      <div class="card mx-auto d-block shadow pt-2 mt-3">
        <p></p>
        <img
          src="../assets/Bild8__Final.jpg"
          class="card-img-top"
          alt="Simple Dokument"
          style="max-height: 60%; max-width: 60%"
        />
        <div class="card-body">
          <p>
            <button
              class="btn btn-outline-secondary"
              data-toggle="modal"
              data-target="#learnMoreModal"
              data-title="titleLearMoreSimpleDocContainer"
              data-body="bodyLearMoreSimpleDocContainer"
              @click.prevent="showmodal"
            >
              {{ $t("learnMore") }}
            </button>
          </p>
          <h5 class="card-title">{{ $t("SimpleDocumentContainer") }}</h5>
          <p class="card-text"></p>
          <router-link
            to="/metadata/files/fileupload"
            class="btn btn-primary mb-3 mt-3"
            :data-toggle="!getAcceptToS ? 'modal' : ''"
            data-target="#ToSModal"
            @click="setContState(false)"
            >{{ $t("createDocument") }}</router-link
          >
        </div>
      </div>

      <div class="card mx-auto d-block shadow pt-2 mt-3">
        <p></p>
        <img
          src="../assets/Bild9__Final.jpg"
          class="card-img-top"
          alt="Documentation Container"
          style="max-height: 100%; max-width: 100%"
        />
        <div class="card-body">
          <p>
            <button
              class="btn btn-outline-secondary"
              data-toggle="modal"
              data-target="#learnMoreModal"
              data-title="titleLearMoreDocContainer"
              data-body="bodyLearMoreDocContainer"
              @click.prevent="showmodal"
            >
              {{ $t("learnMore") }}
            </button>
          </p>
          <h5 class="card-title">{{ $t("documentationContainer") }}</h5>
          <p class="card-text"></p>
          <router-link
            to="/metadata/files"
            class="btn btn-primary mb-3 mt-3"
            :data-toggle="!getAcceptToS ? 'modal' : ''"
            data-target="#ToSModal"
            @click="setContState(true)"
            >{{ $t("createFullDocumentation") }}</router-link
          >
        </div>
      </div>

      <div class="card mx-auto d-block shadow pt-2 mt-3">
        <p></p>
        <img
          src="../assets/Bild10__Final.jpg"
          class="card-img-top"
          alt="Package Unit"
          style="max-height: 58%; max-width: 87%"
        />
        <div class="card-body">
          <p>
            <button
              class="btn btn-outline-secondary"
              data-toggle="modal"
              data-target="#learnMoreModal"
              data-title="homeSubTitel"
              data-body="homeParaOne"
            >
              {{ $t("learnMore") }}
            </button>
          </p>
          <h5 class="card-title">{{ $t("PackageUnitDocumentation") }}</h5>
          <p class="card-text"></p>
          <router-link
            to="/metadata/files"
            class="btn btn-primary mb-3 mt-3"
            :data-toggle="!getAcceptToS ? 'modal' : ''"
            data-target="#ToSModal"
            @click="setContState(true, true)"
            >{{ $t("createPackageUnit") }}</router-link
          >
        </div>
      </div>
    </div>

    <p></p>
    <modal-utils />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalUtils from "../components/utils/ModalsUtils.vue";
import i18n from "@/i18n";

export default {
  name: "HomeView",
  components: {
    ModalUtils,
  },
  computed: {
    ...mapGetters(["getAcceptToS"]),
  },
  methods: {
    ...mapActions("ActSteps", ["setFileUpload"]),
    ...mapActions(["setEditing", "setIsPackageUnit", "setAcceptToS"]),
    checkToS(){
      this.setIsPackageUnit(true)
      $("#ToSModal").on("show.bs.modal", function (event) {
        var title = "ToSshort";
        // var body = "ToSChapter2";
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        // modal.find(".modal-body").text(i18n.global.t(body));
        // modal.find(".modal-body").innerHtml(i18n.global.t(body));
        modal
          .find(".modal-target")
          .text(event.relatedTarget.attributes[0].nodeValue);
      });
    },
    setContState(status, packageUnit = undefined) {
      this.$store.commit("setContainerState", status);
      this.$store.commit("setIsPackageUnit", packageUnit);
      this.showmodalToS();
      if (!status) {
        this.$store.dispatch("ActSteps/setFileUpload", true);
      }
    },
    getGeneralDocuButtonClass() {
      return "btn btn-success btn-lg me-3 mb-3";
    },
    showmodalToS() {
      $("#ToSModal").on("show.bs.modal", function (event) {
        var title = "ToSshort";
        // var body = "ToSChapter2";
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        // modal.find(".modal-body").text(i18n.global.t(body));
        modal
          .find(".modal-target")
          .text(event.relatedTarget.attributes[0].nodeValue);
      });
    },

    showmodal() {
      $("#learnMoreModal").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget); // Button that triggered the modal
        var title = button.data("title");
        var body = button.data("body");
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        modal.find(".modal-body").text(i18n.global.t(body));
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    const access = this.getAcceptToS;
    if (access || to.path == "/privacy" || to.path == "/terms-of-use" || to.path == "/impressum") {
      next();
    } else next(false);
  },
};
</script>
<style scoped>
.capitalize::first-letter {
  font-size: 1.5rem;
  font-weight: bold;
  color: #173c74;
}
.bottom-2 {
  margin-bottom: 2rem;
}
.card {
  max-width: 450px;
}
</style>
